<template>
  <!-- 右侧公共 -->
  <div id="pubRight" class="pubRight">
		<!-- 杂志信息 -->
		<div class="body_content_journal_right">
			<div class="body_content_journal_right_clurmb"><i>版权信息</i></div>
			<div class="body_content_journal_right_content">
				<div class="body_content_journal_right_img">
					<!-- <img src="../../../../static/中国循环杂志/qkfm.png" alt=""> -->
				</div>
				<div class="body_content_journal_right_matter">
					<p>期刊名:&nbsp;&nbsp;&nbsp;中国循环杂志</p>
					<p>Chinese Circulation Journal</p>
					<p>主办:&nbsp;&nbsp;&nbsp;国家心血管病中心</p>
					<p>周期:&nbsp;&nbsp;&nbsp;月刊（自2013年9月起改为月刊）</p>
					<p>创刊时间:&nbsp;&nbsp;&nbsp;1986年</p>
					<p>出版地:&nbsp;&nbsp;&nbsp;北京市</p>
					<p>语 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种: &nbsp;&nbsp;中文</p>
					<p>开 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本: &nbsp;&nbsp;大16开</p>
					<p>ISSN: &nbsp;&nbsp;1000-3614</p>
					<p>CN：&nbsp;&nbsp;11-2212/R</p>
					<p>邮发代号:&nbsp;&nbsp;82-212</p>
					<p>单价:15元/本</p>
					<p style="margin-top:18px;">该刊被以下数据库收录：</p>
					<p>JST 日本科学技术振兴机构数据库(日)(2012年计划收录)</p>
					<p>中国科学引文数据库(CSCD—2008)</p>
					<p>核心期刊：</p>
					<p>中文核心期刊(2008)</p>
					<p>中文核心期刊(2004)</p>
					<p>中文核心期刊(2000)</p>
					<p>中文核心期刊(1996)</p>
					<p>版权说明</p>
					<p>本刊文章和图表均有版权，未经本社书面许可，不得在互联网和其他媒体上转载和翻印，违者必究。</p>
				</div>
			</div>
		</div>
		<!-- 图片 -->
		<div class="body_content_journal_right_img_ther">
			<!-- <img src="../../../../static/中国循环杂志/bannera.png" alt=""> -->
		</div>
		<!-- 友情链接 -->
		<!-- <div class="body_content_circle_right_cont">
			<div class="body_content_circle_right_clurmb"><i>友情链接</i></div>
			<div class="body_content_circle_right_content_cot">
				<ul>
					<li v-for="(item,index) in blogrollList" :key="index">
						<i class="iconfont icon-fangkuai"></i>
						<span><a>{{item.title}}</a></span>
					</li>
				</ul>
			</div>
		</div> -->
  </div>
</template>
<script>
import router from '@/router/index'
import $ from 'jquery'
import Swiper from 'swiper'
import axios from 'axios'
import { mixin } from "../../../assets/script/scrollnav";
import { pagination } from '../../../../src/assets/mixin/data-table'

export default {
  name:'pubRight',
  mixins: [pagination],
  data(){
    return{
			blogrollList:[
        {title:'中国知网'},
        {title:'维普数据库'},
        {title:'Pubmed文献数据库'},
        {title:'万方数据知识服务平台'},
      ],
    }
  },
  methods:{

  },
  components:{

  },
  created(){

  },
  computed: {

  },
}
</script>

<style lang="less" scoped>
  #pubRight{
		float: right;
		width: 248px;
		.body_content_journal_right{
			border:1px solid #BDBDBD;
			border-top:6px solid #b80000;
			.body_content_journal_right_clurmb{
				height: 55px;
				font-size:20px;
				font-weight:400;
				color: #b80000;
				font-weight: bold;
				text-align: center;
				line-height: 55px;
				border-bottom: 1px solid #AAAAAA;
				letter-spacing: 3px;
				i{
					font-style: italic;
				}
			}
			.body_content_journal_right_content{
				width: 100%;
				height: auto;
				padding: 12px 17px 17px 17px;
				.body_content_journal_right_img{
					width: 100%;
					border:1px solid #BDBDBD;
					img{
						width: 100%;
					}
				}
				.body_content_journal_right_matter{
					margin-top:13px;
					p{
						color:#010101;
						font-size:12px;
						font-weight: bold;
						margin-bottom: 2px;
					}
				}
			}
		}
		// 图片
		.body_content_journal_right_img_ther{
			width: 100%;
			height: 116px;
			margin-top: 13px;
			img{
				width: 100%;
				height: 100%;
			}
		}
		// 友情链接
		.body_content_circle_right_cont{
			width: 248px;
			border:1px solid #BDBDBD;
			border-top:6px solid #b80000;
			margin-top:56px;
			.body_content_circle_right_clurmb{
				height: 55px;
				font-size:20px;
				font-weight:400;
				color: #b80000;
				font-weight: bold;
				text-align: center;
				line-height: 55px;
				border-bottom: 1px solid #AAAAAA;
				letter-spacing: 3px;
				i{
					font-style: italic;
				}
			}
			.body_content_circle_right_content{
				padding:20px 13px 10px 14px;
				el-input{
					width:100%;
				}
				p{
					margin-top:12px;
					color:#4C4C4C;
					font-size:14px;
				}
			}
			.body_content_circle_right_content_cot{
				padding:17px 14px 14px 13px;
				height: 169px;
				ul{
					width: 100%;
					height: 100%;
					overflow: hidden;
					overflow-y: auto;
					li{
						width: 100%;
						margin-bottom: 9px;
						i{
							color: #b80000;
							font-size: 18px;
							margin-right: 7px;
						}
						span{
							a{
								font-size: 14px;
								color: #000;
							}
						}
					}
					li:hover{
						span{
							a{
								color: #b80000;
							}
						}
					}
				}
				ul::-webkit-scrollbar{
					display: none;
				}
			}
		}
	}
	@media screen and (max-width:1010px){
		#pubRight{
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/public/pubRight/index.vue